class Usercentrics {

  static init () {
    if (window.UC_UI && window.UC_UI.isInitialized()) {
      if(document.querySelectorAll('[data-uc="1"]').length) {
        window.UC_UI.closeCMP();
      }

      Usercentrics.setLanguage();

      for(let s of Array.from(window.UC_UI.getServicesBaseInfo())) {
        if(s.name === 'Juicer' && s.consent.status) {
          Usercentrics.hideUCJuicerOverlay();
        }
        if(s.name === 'YouTube Video' && s.consent.status) {
          window.ytallowed = true;
        }
        if(s.name === 'Vimeo' && s.consent.status) {
          window.vimallowed = true;
        }
      }

    } else {
      window.addEventListener('UC_UI_INITIALIZED', function(e) {

        if(document.querySelectorAll('[data-uc="1"]').length) {
          window.UC_UI.closeCMP();
        }

        for(let s of Array.from(window.UC_UI.getServicesBaseInfo())) {
          if(s.name === 'Juicer' && s.consent.status) {
            Usercentrics.hideUCJuicerOverlay();
          }
          if(s.name === 'YouTube Video' && s.consent.status) {
            window.ytallowed = true;
          }
          if(s.name === 'Vimeo' && s.consent.status) {
            window.vimallowed = true;
          }
        }

        Usercentrics.setLanguage();
      });
    }
  }

  static setLanguage () {
    if(document.documentElement.lang.indexOf('de') > -1) {
      window.UC_UI.updateLanguage('de');
    } else {
      window.UC_UI.updateLanguage('en');
    }
  }

  static handleJuicer () {
    window.addEventListener('ucEvent', function (e) {
      if(e.detail && e.detail.event === 'consent_status') {
        if (e.detail['Juicer']) {
          Usercentrics.hideUCJuicerOverlay();
        }
      }
    });
  }

  static hideUCJuicerOverlay () {
    let juicers = document.getElementsByClassName('juicer-wrapper');

    for(let juicer of Array.from(juicers)) {
      juicer.getElementsByClassName('usercentrics-cookie-banner')[0].style.display = 'none';
    }
  }

  static handleYoutube () {

    window.addEventListener('ucEvent', function (e) {
      if(e.detail && e.detail.event === 'consent_status') {
        window.ytallowed = e.detail['YouTube Video'];
      }
    });
  }

  static handleVimeo () {

    window.addEventListener('ucEvent', function (e) {
      if(e.detail && e.detail.event === 'consent_status') {
        window.vimallowed = e.detail['Vimeo'];
      }
    });
  }
}

export {
  Usercentrics
}